import React, { useRef, useEffect } from "react";

function ImageArrayAnimation({ imageArray }) {
  const canvasRef = useRef(null);
  let currentFrameIndex = 0;
  let animationFrameId = null;

  const drawFrame = () => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const img = new Image();
    img.src = imageArray[currentFrameIndex];

    img.onload = () => {
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      currentFrameIndex = (currentFrameIndex + 1) % imageArray.length;
      animationFrameId = requestAnimationFrame(drawFrame);
    };
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = 800; // Set canvas width and height accordingly
    canvas.height = 600;
    drawFrame();

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [imageArray]);

  return <canvas ref={canvasRef} />;
}

export default ImageArrayAnimation;
